import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
// import store from '../../store';
import Login from '../../containers/login';

export const ProtectedRoute = ({ component, ...rest }) => (
    <Route {...rest} render={(restProps) => requireLoggedIn(component, restProps)}  />
)
  
const requireLoggedIn = (Component, restProps) => {

    // const state = window.getloca;
    const isLoggedIn = localStorage.getItem('token');
    // console.log('isLoggedIn >>', isLoggedIn);
  
    if (isLoggedIn) {
      return <Component {...restProps} />
    } else {
        return <Login {...restProps} />
    }
}

// ProtectedRoute.propTypes = {
//     component: PropTypes.ReactNode.isRequired,
// };

